// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarElevationChart_container__VpTg3"};